import React from "react";
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
  alpha,
  lighten,
  darken
} from "@mui/material/styles";

const baseTheme = createTheme(
  /**
   * @see https://material-ui.com/customization/themes/#theme-configuration-variables
   */
  {
    // direction: "rtl",
    typography: {
      fontFamily: ["Poppins"].join(",")
    },

    palette: {
      contrastThreshold: 4.5,
      primary: {
        // light: will be calculated from palette.primary.main,
        main: "#5d78ff"
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        // light: will be calculated from palette.primary.main,
        main: "#0abb87"
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.secondary.main
      },
      error: {
        // light: will be calculated from palette.primary.main,
        main: "#fd397a"
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      }
    },

    /**
     * @see https://mui.com/material-ui/customization/theme-components/#default-props
     */
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true // No more ripple, on the whole application 💣!
        }
      },
      MuiPopover: {
        defaultProps: {
          elevation: 1
        }
      }
    }
  }
);

// Add color manipulation functions to theme for @material-table/core compatibility
const theme = {
  ...baseTheme,
  alpha: alpha,
  lighten: lighten,
  darken: darken
};

export default function ThemeProvider(props) {
  const { children } = props;

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
